export default "__VITE_ASSET__C_tQIQ4N__"